import { SelectBox } from 'devextreme-react';
import _ from 'lodash';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
    Button,
    Card,
    CardBody,
    Col,
    Collapse,
    Form,
    FormGroup,
    Input,
    Label,
    Row
} from 'reactstrap';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { useAuth } from '../../auth';
import Breadcrumb from '../../components/common/breadcrumb';
import api from '../../services/api-configuration';
import { getAllWarehouses } from '../../services/apis';
import { getTaseron } from '../../services/getTaseron';

const TransferGroupageForm = () => {
    const [warehouses, setWarehouses] = useState([]);
    const [peron, setPeron] = useState([]);
    const [contractors, setContractors] = useState([]);
    const [chassisList, setChassisList] = useState([]);
    const [open, setIsOpen] = useState(false);
    const [sevkiyatTipi, setSevkiyatTipi] = useState([]);
    const [barcodeInput, setBarcodeInput] = useState('');
    const { hasRole } = useAuth(7);
    const [truckDetails, setTruckDetails] = useState({
        driver_name: '',
        driver_phone: '',
        plate_number: '',
        trailer_plate: '',
        subcontractor_id: null
    });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchInitialData();
        if (localStorage.getItem("warehouse") !== null ||
            localStorage.getItem("warehouse") !== undefined ||
            localStorage.getItem("warehouse") !== ""

        ) {
            fetchPeron(parseInt(Buffer.from(localStorage.getItem("warehouse"), 'base64').toString('ascii')));
        }


    }, []);

    // Barcode scanner handling
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (document.activeElement.tagName !== 'INPUT') {
                if (event.key === 'Enter') {
                    if (barcodeInput) {
                        const chassisInput = document.getElementById('chassis');
                        if (chassisInput) {
                            chassisInput.value = barcodeInput;
                            handleAddChassis();
                        }
                        setBarcodeInput('');
                    }
                    event.preventDefault();
                } else if (event.key.length === 1) {
                    setBarcodeInput(prev => prev + event.key);
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [barcodeInput]);

    const fetchInitialData = async () => {
        try {
            await Promise.all([
                fetchWarehouses(),
                fetchPeron(),
                fetchContractors(),
                fetchSevkiyatTipi()
            ]);
        } catch (err) {
            toast.error("Veri yüklenirken hata oluştu");
        }
    };

    // API calls (implementation remains the same)
    const fetchWarehouses = async () => {
        try {
            const res = await getAllWarehouses();
            setWarehouses(res || []);
        } catch (err) {
            toast.error("Depo Listesi Alınırken hata oluştu");
        }
    };

    const fetchPeron = useCallback(_.debounce(async (value) => {
        if (!value) return;

        try {
            const response = await api.post("getPeronsByWarehouses", {
                warehouse_ids: [parseInt(value)]
            });
            const all_data = response.data.data || [];
            all_data.sort((a, b) => {
                // Helper function to get status (0: empty, 1: partial, 2: full)
                const getStatus = (item) => {
                    if (item.used_capacity === 0 && item.reserved_capacity === 0) return 0; // boş
                    if (item.used_capacity + item.reserved_capacity >= item.capacity) return 2; // dolu
                    return 1; // orta
                };

                const statusA = getStatus(a);
                const statusB = getStatus(b);

                // Önce duruma göre sırala
                if (statusA !== statusB) {
                    return statusA - statusB;
                }

                // Aynı durumdaki öğeler için address_code'a göre sırala
                return a.address_code.localeCompare(b.address_code);
            });

            // PP-999 gelmeli sadece 
            // address_code === PP-999

            if (all_data.filter(item => item.address_code === "PP-999").length === 0) {
                toast.error("seçili depo altında PP-999 bulunamadı")
            }
            else setPeron(all_data.filter(item => item.address_code === "PP-999"));

            if (all_data?.length === 0) {
                toast.error("Peron bulunamadı. Lütfen seçili depo için peron ve adres tanımlayın.", {
                    autoClose: 10000
                });
            }
        } catch (error) {
            toast.error("Hata oluştu");
            console.error("Error fetching route:", error);
        }
    }, 300), []);
    const fetchContractors = async () => {
        try {
            const response = await getTaseron({ contract_owner: true })

            setContractors(response);
        } catch (error) {
            console.error("Taşıyıcı firma listesi alınamadı:", error);
            toast.error("Taşıyıcı firma listesi alınamadı");
            setContractors([]); // Ensure contractors is always an array
        }
    };

    const fetchSevkiyatTipi = async () => {
        try {
            const response = await api.post("/shippingType/getAll");
            setSevkiyatTipi(response.data.data?.filter(item => item.is_active && item.id !== 2) || []);
        } catch (error) {
            toast.error("Sevkiyat tipi listesi alınamadı");
        }
    };

    const handleAddChassis = async () => {
        const chassisInput = document.getElementById('chassis');
        const chassisValue = chassisInput?.value?.trim();

        if (!chassisValue) {
            toast.error("Lütfen şase numarası giriniz");
            return;
        }

        // Check duplicates with safe access
        if (chassisList?.some(c => c?.chassis_no === chassisValue)) {
            toast.error("Bu şase numarası zaten ekli");
            return;
        }

        try {
            const response = await api.post("/validateTransferEligibility", {
                chassis_numbers: [chassisValue]
            });

            if (!response?.data?.success) {
                toast.error(response?.data?.error ?? "Şase kontrolü başarısız");
                return;
            }

            const chassisData = response?.data?.results?.[0];
            if (!chassisData) {
                toast.error("Şase bilgisi bulunamadı");
                return;
            }

            if (!chassisData.is_eligible) {
                Swal.fire({
                    title: 'Uyarı',
                    text: chassisData.warning_message ?? 'Bu şase transfere uygun değil',
                    icon: 'warning',
                    confirmButtonText: 'Tamam'
                });
                return;
            }

            setChassisList(prevList => [...(prevList ?? []), {
                chassis_no: chassisValue,
                customs_cleared: chassisData.customs_cleared ?? false,
                model: chassisData.model ?? '',
                color: chassisData.color ?? ''
            }]);

            if (chassisInput) {
                chassisInput.value = '';
            }
        } catch (error) {
            console.error("Şase kontrolü hatası:", error);
            toast.error("Şase kontrolü sırasında hata oluştu");
        }
    };

    const validateTruckDetails = () => {
        if (chassisList.length === 0) {
            toast.error("Şase numarası eklemelisiniz");
            return false;
        }
        //peron
        if (document.getElementById("peron-select").childNodes[0].childNodes[0].value === "") {
            toast.error("Peron seçmelisiniz");
            return false;
        }
        if (!truckDetails.driver_name) {
            toast.error("Şoför adı boş olamaz");
            return false;
        }
        if (!truckDetails.plate_number) {
            toast.error("Plaka boş olamaz");
            return false;
        }

        // License plate format validation (2 numbers + any letters + any numbers)
        const plateRegex = /^[0-9]{2}[A-Z]+[0-9]+$/
        if (!plateRegex.test(truckDetails.plate_number)) {
            toast.error('Geçerli bir plaka formatı giriniz. Örn: 34ABC123')
            return false
        }
        if (!truckDetails.subcontractor_id) {
            toast.error("Taşıyıcı firma boş olamaz");
            return false;
        }

        return true;
    };

    const handleConfirm = async () => {
        if (isLoading) return; // Prevent double submission

        const fromWarehouseId = document.getElementById("from-warehouse-select").childNodes[0].childNodes[0].value;
        const toWarehouseId = document.getElementById("to-warehouse-select").childNodes[0].childNodes[0].value;

        if (!fromWarehouseId || !toWarehouseId) {
            toast.error("Lütfen kaynak ve hedef depoları seçiniz");
            return;
        }

        if (!validateTruckDetails()) {
            return;
        }

        const selectedFromWarehouse = warehouses.find(w => w.id === parseInt(fromWarehouseId));
        const selectedToWarehouse = warehouses.find(w => w.id === parseInt(toWarehouseId));

        const transferBody = {
            address_id: parseInt(document.getElementById("peron-select").childNodes[0].childNodes[0].value),
            chassis_numbers: _.uniq(chassisList.map(c => c.chassis_no)),
            contractor_id: parseInt(truckDetails.subcontractor_id),
            from_warehouse_id: parseInt(fromWarehouseId),
            to_warehouse_id: parseInt(toWarehouseId),
            shipping_date: moment(new Date()).format("YYYY-MM-DD"),
            shipping_type_id: 4,
            groupage_type: "MULTIPLE"
        };

        try {
            const result = await Swal.fire({
                title: 'Transfer',
                html: `${chassisList.length} araç
            ${selectedFromWarehouse.warehouse_name}
            ↓
            ${selectedToWarehouse.warehouse_name}`,
                showCancelButton: true,
                confirmButtonText: 'OK',
                cancelButtonText: 'İptal',
                cancelButtonColor: '#d33',
                width: '380px',
                customClass: {
                    container: 'terminal-alert',
                    popup: 'terminal-popup',
                    title: 'terminal-title',
                    htmlContainer: 'terminal-text',
                    confirmButton: 'terminal-confirm',
                    cancelButton: 'terminal-cancel'
                }
            });

            if (result.isConfirmed) {
                setIsLoading(true);
                try {
                    const transferResponse = await api.post("/createWarehouseTransfer", transferBody);

                    const truckAssignBody = {
                        groupage_no: transferResponse.data[0].groupage_no,
                        driver_name: truckDetails.driver_name,
                        driver_phone: "",
                        plate_number: truckDetails.plate_number,
                        trailer_plate: truckDetails.trailer_plate,
                        subcontractor_id: parseInt(truckDetails.subcontractor_id),
                        user_id: parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'))
                    };

                    await api.post("/assignTruck", truckAssignBody);

                    toast.success("Transfer ve tır eşleme işlemi başarıyla tamamlandı");
                    setChassisList([]);
                    setTruckDetails({
                        driver_name: '',
                        driver_phone: '',
                        plate_number: '',
                        trailer_plate: '',
                        subcontractor_id: null
                    });
                } catch (error) {
                    console.log("Transfer hatası:", {
                        error: error,
                        response: error?.response?.data,
                        status: error?.response?.status
                    });
                    let errorMessage = error?.response?.data?.error || "İşlem sırasında hata oluştu";
                    toast.error("HATA: " + errorMessage);
                }
            }
        } catch (error) {
            toast.error("İşlem sırasında hata oluştu");
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Breadcrumb current="Depolar Arası Transfer" />
            <Card className="shadow-sm">
                <CardBody>
                    <Form>
                        <Row>
                            <Col md="6">
                                {/* Transfer Form Fields */}
                                <div>

                                </div>
                                <Row>
                                    <Col className='pr-0'>
                                        <FormGroup>
                                            <Label className='text-muted small'>Nereden</Label>
                                            <SelectBox
                                                defaultValue={localStorage.getItem("warehouse") ? parseInt(Buffer.from(localStorage.getItem("warehouse"), 'base64').toString('ascii')) : null}
                                                id='from-warehouse-select'
                                                placeholder="Depo Seçiniz"
                                                dataSource={warehouses && warehouses.filter((item) => item.id !== 34)}
                                                displayExpr="warehouse_name"
                                                valueExpr="id"
                                                searchEnabled={true}
                                                className="w-100"
                                                onValueChange={(e) => {
                                                    fetchPeron(e)
                                                }}
                                            />
                                        </FormGroup>

                                    </Col>
                                    <Col className='pl-0'>
                                        <FormGroup>
                                            <Label className='text-muted small'>Nereye</Label>
                                            <SelectBox
                                                id='to-warehouse-select'
                                                placeholder="Depo Seçiniz"
                                                dataSource={warehouses && warehouses.filter((item) => item.id !== 34)}
                                                displayExpr="warehouse_name"
                                                valueExpr="id"
                                                searchEnabled={true}
                                                className="w-100"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <FormGroup className="mb-3">
                                    <Label className="text-muted small">Peron</Label>
                                    <SelectBox
                                        id='peron-select'
                                        placeholder="Peron Seçiniz"
                                        dataSource={peron}
                                        value={peron?.length > 0 ? peron[0].address_id : null}
                                        disabled
                                        displayExpr={(item) => {
                                            return (item ? `${item.zone_name} ${item.address_code} | (${item.used_capacity + item.reserved_capacity}/${item.capacity})` : '')
                                        }
                                        }
                                        valueExpr="address_id"
                                        searchEnabled={true}
                                        className="w-100"
                                    />
                                </FormGroup>

                                {/* Truck Assignment Fields */}
                                <FormGroup className="mb-3">
                                    <Label className="text-muted small">Taşıyıcı Firma</Label>
                                    <SelectBox
                                        value={truckDetails.subcontractor_id}
                                        placeholder="Taşıyıcı Firma Seçiniz"
                                        dataSource={contractors}
                                        displayExpr="name"
                                        valueExpr="id"
                                        searchEnabled={true}
                                        className="w-100"
                                        onValueChanged={(e) => setTruckDetails(prev => ({
                                            ...prev,
                                            subcontractor_id: e.value
                                        }))}
                                    />
                                </FormGroup>

                                <FormGroup className="mb-3">
                                    <Label className="text-muted small">Şoför Adı</Label>
                                    <Input
                                        value={truckDetails.driver_name}
                                        onChange={(e) => {
                                            // Only allow letters, spaces, and Turkish characters
                                            const cleaned = e.target.value.replace(/[^a-zA-ZğüşıöçĞÜŞİÖÇ\s]/g, '')
                                            setTruckDetails(prev => ({
                                                ...prev,
                                                driver_name: cleaned
                                            }))
                                        }}
                                        placeholder="Şoför adını giriniz"
                                    />
                                </FormGroup>

                                {/* <FormGroup className="mb-3">
                                <Label className="text-muted small">Şoför Telefon</Label>
                                <TextBox
                                    mask="(000)000 00 00"
                                    value={truckDetails.driver_phone}
                                    onValueChanged={(e) => setTruckDetails(prev => ({
                                        ...prev,
                                        driver_phone: e.value
                                    }))}
                                    maskRules={{ '0': /[0-9]/ }}
                                />
                            </FormGroup> */}

                                <FormGroup className="mb-3">
                                    <Label className="text-muted small">Plaka/Dorse</Label>
                                    <Row className="g-2">
                                        <Col>
                                            <Input
                                                value={truckDetails.plate_number}
                                                onChange={(e) => {
                                                    // Format as Turkish license plate: Number-Letters-Number
                                                    const cleaned = e.target.value.replace(/[^0-9A-Za-z]/g, '').toUpperCase()
                                                    let formatted = ''

                                                    if (cleaned.length <= 2) {
                                                        // First part (numbers only)
                                                        const numbers = cleaned.replace(/[^0-9]/g, '')
                                                        formatted = numbers
                                                    } else {
                                                        // Split into parts: first 2 numbers, then letters, then remaining numbers
                                                        const firstPart = cleaned.slice(0, 2).replace(/[^0-9]/g, '')
                                                        const remainingPart = cleaned.slice(2)
                                                        const letters = remainingPart.replace(/[^A-Z]/g, '')
                                                        const numbers = remainingPart.replace(/[^0-9]/g, '')

                                                        formatted = firstPart + letters + numbers
                                                    }

                                                    setTruckDetails(prev => ({
                                                        ...prev,
                                                        plate_number: formatted
                                                    }))
                                                }}
                                                placeholder="Araç plakası"
                                            />
                                        </Col>
                                        <Col>
                                            <Input
                                                value={truckDetails.trailer_plate}
                                                onChange={(e) => setTruckDetails(prev => ({
                                                    ...prev,
                                                    trailer_plate: e.target.value.toUpperCase()
                                                }))}
                                                placeholder="Dorse"
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>

                                {/* <FormGroup className="mb-3">
                                <Label className="text-muted small">Sevkiyat Tipi</Label>
                                <SelectBox
                                    id='sevkiyat-select'
                                    placeholder="Sevkiyat Tipi Seçiniz"
                                    dataSource={sevkiyatTipi}
                                    displayExpr="type_name"
                                    valueExpr="id"
                                    searchEnabled={true}
                                    className="w-100"
                                />
                            </FormGroup> */}

                                <FormGroup className="mb-3">
                                    <Label className="text-muted small">Şase</Label>
                                    <Row className="g-1">
                                        <Col xs="10">
                                            <Input
                                                // input önermeyi kapat
                                                autoComplete="off"
                                                id="chassis"
                                                placeholder="Şasi No Giriniz"
                                                type="text"
                                            />
                                        </Col>
                                        <Col xs="2" className="pl-0">
                                            <Button
                                                color="warning"
                                                disabled={!(hasRole("depolararasi_transfer_write"))}
                                                className="w-100"
                                                style={{ paddingInline: '5px' }}
                                                onClick={handleAddChassis}
                                            >
                                                <i className="fa fa-plus"></i>
                                            </Button>
                                        </Col>
                                    </Row>
                                </FormGroup>

                                <div
                                    className="d-flex justify-content-between align-items-center p-2 bg-light rounded mb-3"
                                    onClick={() => setIsOpen(!open)}
                                    style={{
                                        cursor: 'pointer',
                                        color: 'black',
                                    }}
                                >
                                    <b>
                                        <i className={`fa fa-chevron-${open ? 'up' : 'down'}`}></i>
                                        <span className="ms-2"> &nbsp;Şase Listesi</span>
                                    </b>
                                    <b className="text-success">
                                        {chassisList.length}
                                    </b>
                                </div>

                                <Collapse isOpen={open}>
                                    {chassisList.length > 0 && (
                                        <div className="bg-light p-2 rounded mb-3">
                                            {chassisList.map((chassis) => {

                                                return (
                                                    <div key={chassis.chassis_no} className="mb-1 p-2 border rounded d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <span style={{ color: 'black', fontWeight: 'bold' }}>
                                                                {chassis.chassis_no}
                                                            </span>
                                                            <div style={{ fontSize: '0.9em', color: 'gray' }}>
                                                                Model: {chassis.model} | Color: {chassis.color}
                                                            </div>
                                                        </div>
                                                        <i
                                                            style={{ color: 'red', cursor: 'pointer' }}
                                                            onClick={() => {
                                                                setChassisList(prevList =>
                                                                    prevList.filter(item => item.chassis_no !== chassis.chassis_no)
                                                                );
                                                            }}
                                                            className="fa fa-times"
                                                        ></i>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )}
                                </Collapse>

                                {hasRole("depolararasi_transfer_write") && <Button
                                    color="success"
                                    className="w-100"
                                    onClick={handleConfirm}
                                    disabled={chassisList.length === 0 || isLoading}
                                >
                                    <i className="fa fa-check me-1"></i>
                                    {isLoading ? 'İŞLEM YAPILIYOR...' : 'ONAYLA'}
                                </Button>}
                            </Col>
                        </Row>
                    </Form>
                </CardBody>

                <style>
                    {`
                    .mobile-swal-container {
                        padding: 10px;
                    }
                    .mobile-swal-popup {
                        width: 90% !important;
                        font-size: 14px !important;
                        padding: 10px !important;
                    }
                    .text-muted.small {
                        font-size: 0.875rem;
                    }
                `}
                </style>
            </Card>
        </>
    );
};

export default TransferGroupageForm;